// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__OW18v","header":"Messages_header__3NxeR"};